import React from 'react';

import { User } from '@repo/domain/user';
import { buildWebsiteUrl, TUTORIALS_PAGE_URL } from '@repo/utils/url';

import ShowcaseContent from './ShowcaseContent/ShowcaseContent';

const items = [
  {
    imgSrc: '/images/tipsAndTricks.png',
    href: TUTORIALS_PAGE_URL,
    heading: 'Learn tips & tricks',
    description: 'Short videos to inspire and expand your Kittl skillset',
  },
  {
    imgSrc: '/images/kittlAi.png',
    href: buildWebsiteUrl('/feature/kittl-ai-prompt-book'),
    heading: 'Explore AI',
    description: 'Use the power of AI to generate unique content',
  },
  {
    imgSrc: '/images/mockups.png',
    href: buildWebsiteUrl('/tools/mockups'),
    heading: 'Check out mockups',
    description: 'Show off your design in real life context',
  },
];

const CongratulationsContent: React.FC<{ user: User }> = (props) => {
  const heading = `Great choice, ${props.user.name}`;

  return (
    <ShowcaseContent
      heading={heading}
      primaryButton={{
        label: 'Back to Profile',
        onClick: (): void => {
          window.open(buildWebsiteUrl('/user/dashboard'));
        },
      }}
      showcaseItems={items}
      subheading="What would you like to do next?"
    />
  );
};

export default CongratulationsContent;
